/**
 * Root Sagas
 */
import { all } from 'redux-saga/effects'
// sagas
import homeSagas from './home'

export default function * rootSaga (getState) {
  yield all([
    homeSagas(),
  ])
}